window.RSSearch = (function () {
  const INDEX_URL = '/pages/search-index'; // adjust to your actual page handle
  const CACHE_KEY = 'rs_search_index_v1';
  const CACHE_TTL_MS = 1000 * 60 * 30; // 30 min

  let fuse = null;
  let productIndex = [];
  let isLoading = false;
  let loadError = null;

  const FUSE_OPTIONS = {
    keys: [
      { name: 'title', weight: 0.45 },
      { name: 'tags', weight: 0.25 },
      { name: 'product_type', weight: 0.15 },
      { name: 'vendor', weight: 0.05 },
      { name: 'description', weight: 0.1 }
    ],
    threshold: 0.4,
    ignoreLocation: true,
    minMatchCharLength: 2
  };

  async function fetchAllPages() {
    let page = 1;
    let allProducts = [];
    let hasNext = true;

    while (hasNext) {
      const res = await fetch(`${INDEX_URL}?page=${page}`);
      if (!res.ok) throw new Error(`Search index fetch failed: ${res.status}`);
      const data = await res.json();
      allProducts = allProducts.concat(data.products);
      hasNext = data.has_next;
      page += 1;
    }
    return allProducts;
  }

  async function loadIndex() {
    isLoading = true;
    loadError = null;

    try {
      const cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) {
        try {
          const parsed = JSON.parse(cached);
          if (Date.now() - parsed.ts < CACHE_TTL_MS && Array.isArray(parsed.data)) {
            productIndex = parsed.data;
            buildFuse();
            isLoading = false;
            return productIndex;
          }
        } catch (e) {
          sessionStorage.removeItem(CACHE_KEY);
        }
      }

      productIndex = await fetchAllPages();

      try {
        sessionStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), data: productIndex }));
      } catch (e) {
        // sessionStorage full or unavailable - non-fatal
      }

      buildFuse();
      return productIndex;
    } catch (err) {
      loadError = err;
      productIndex = [];
      fuse = null;
      return [];
    } finally {
      isLoading = false;
    }
  }

  function buildFuse() {
    fuse = new Fuse(productIndex, FUSE_OPTIONS);
  }

  function debounce(fn, wait) {
    let t;
    return function (...args) {
      clearTimeout(t);
      return new Promise((resolve) => {
        t = setTimeout(() => resolve(fn(...args)), wait);
      });
    };
  }

  function _search(query, { limit = 6, facets = {} } = {}) {
    if (!fuse) return [];

    let pool = productIndex;

    if (facets.collection) {
      pool = pool.filter((p) => Array.isArray(p.collections) && p.collections.includes(facets.collection));
    }
    if (facets.priceMin != null && facets.priceMin !== '') {
      pool = pool.filter((p) => p.price_min >= Number(facets.priceMin));
    }
    if (facets.priceMax != null && facets.priceMax !== '') {
      pool = pool.filter((p) => p.price_min <= Number(facets.priceMax));
    }

    if (!query || !query.trim()) {
      return pool.slice(0, limit);
    }

    const scopedFuse = new Fuse(pool, FUSE_OPTIONS);
    return scopedFuse.search(query).slice(0, limit).map((r) => r.item);
  }

  const search = debounce(_search, 200);

  return {
    loadIndex,
    search,
    searchImmediate: _search,
    getIndex: () => productIndex,
    isLoading: () => isLoading,
    getError: () => loadError
  };
})();